import { isEqual,isEmpty,isFinite,isPlainObject } from "lodash";
import CryptoJS from "crypto-js";

const Tools = {
    domainName: "/v1/web",
    addEvent (element,eventType,handler){  // 添加事件监听
        if(element.addEventListener){ 
            element.addEventListener(eventType,handler,false); 
        }else if(element.attachEvent){ 
            element.attachEvent(`on${eventType}`,handler); 
        } 
    },
    getQuery (paramName){   // 获取url问号之后的param参数的value
        if(paramName && typeof paramName === "string"){
            let sValue="";
            const re= new RegExp(`${paramName}=([^&=]+)`);
            let st=null;
            st=window.location.search.match(re);
            if(st&&st.length==2){   
                st[1]=st[1].replace(/^\s*|\s*$/g,"");
                sValue=st[1];
                if(sValue == ""){
                    return null;
                }
                    return sValue;
                
            }
                return st;
            
        }
    },
    filterParam (obj) {  // 对对象直接量进行过滤（不含空值）
        const parameter = {};
        if(isPlainObject(obj)){
            // _.forIn(obj, function(value, key) {
            //     if(!this._isEmpty(value) && value !== 'NaN'){
            //         parameter[key] = value;
            //     }
            // }.bind(this));
            for(const key in obj){
                if(!this._isEmpty(obj[key]) && !this._isNaN(obj[key])){
                    parameter[key] = obj[key];
                }
            }
        }
        return parameter;
    },
    deepCopyObj(obj){  // 对象深复制
        const result={};

        for (const key in obj) {
            result[key] = isPlainObject(obj[key]) ? this.deepCopyObj(obj[key]): obj[key];
        } 
        return result; 
    },
    sortedUniq(arr){  // 数组去重
        if(!this.isArray(arr)){
            return null;
        } 
        const newArr = [];
        arr.forEach((ele,i,self) => {
            if(i == 0){
                newArr.push(ele);
            }else if(this.isString(ele) || this.isNumber(ele) || this.isBoolean(ele)){
                    if(ele !== self[i-1]){
                        newArr.push(ele);
                    }
                }else if(!isEqual(ele,self[i-1])){
                        newArr.push(ele);
                    }
            
        });
        return newArr;
    },
    randomColor(){  // 返回随机颜色字符串
      return(`#${Math.floor(Math.random()*0xffffff).toString(16)}`);
    },
    // add zero
    addZero(num,len=2) {
       return num.padStart(len,"0");
    },
    // 生成hover颜色(将颜色加深)
    getHoverColor(rgb) {
      if (!rgb) return "#ff0000";
      let r = Math.floor(parseInt(rgb.slice(1,3),16)*0.8).toString(16);
      let g = Math.floor(parseInt(rgb.slice(3,5),16)*0.8).toString(16);
      let b = Math.floor(parseInt(rgb.slice(5,7),16)*0.8).toString(16);
      return "#"+ this.addZero(r) + this.addZero(g) + this.addZero(b);
    },
    checkTelephone(val){  // 验证手机号码的格式
        const reg = /^((13\d)|(15[012356789])|(17[0678])|(18\d))\d{8}$/;
        return reg.test(val);
    },
    checkPhone(val){   // 验证座机的格式
        const reg =  /^0\d{2,3}-?\d{7,8}$/;
        return reg.test(val);
    },
    isObject(value) {  // 包含函数类型
      const type = typeof value;
      return !!value && (type === "object" || type === "function");
    },
    isObjectLike(value){  // 不包含函数类型
        return !!value && typeof value === "object";
    },
    isBoolean(value) {
        const boolTag = "[object Boolean]";
        const objectToString = Object.prototype.toString;
        return value === true || value === false ||
        (this.isObjectLike(value) && objectToString.call(value) === boolTag);
    },
    isString(value) {
        const stringTag = "[object String]";
        const objectToString = Object.prototype.toString;

        return typeof value === "string" ||
        (!this.isArray(value) && this.isObjectLike(value) && objectToString.call(value) === stringTag);
    },
    isNumber(value) {
        const numberTag = "[object Number]";
        const objectToString = Object.prototype.toString;

        return typeof value === "number" ||
        (this.isObjectLike(value) && objectToString.call(value) === numberTag);
    },
    isArray(value){  // 判断一个对象是不是数组类型
        const arrTag = "[object Array]";
        const objectToString = Object.prototype.toString;
        return (Array.isArray && Array.isArray(value)) || (objectToString.call(value) === arrTag);
    },
    isFunction(value){  // 判断一个对象是不是数组类型
        const objectToString = Object.prototype.toString;
        const funcTag = "[object Function]";
        const genTag = "[object GeneratorFunction]";
        const tag = this.isObject(value) ? objectToString.call(value) : "";
        return tag === funcTag || tag === genTag;
    },
    isRegExp(value){  // 判断一个对象是不是数组类型
        const objectToString = Object.prototype.toString;
        const regexpTag = "[object RegExp]";

        return this.isObject(value) && objectToString.call(value) === regexpTag;
    },
    isDate(value){  // 判断一个对象是不是数组类型
        const dateTag = "[object Date]";
        const objectToString = Object.prototype.toString;
        return this.isObjectLike(value) && (objectToString.call(value) === dateTag);
    }, 
    isNull(value) {
      return value === null;
    }, 
    isUndefined(value) {
      return value === undefined;
    },
    _isNaN(value) {
      return this.isNumber(value) && value != +value;
    },
    _isEmpty (value) {  // 判断值是否为空
        return (this.isString(value) && isEmpty(value)) || this.isNull(value) || this.isUndefined(value);
    },
    getExtensionName (path){  // 获取path路径中文件的扩展名
        if(typeof path === "string"){
            const index = path.lastIndexOf(".");  
            return path.slice(index+1); 
        }    
    },
    setCookie(name, value, expireTimes){
        const exdate=new Date();
    　　exdate.setTime(exdate.getTime() + expireTimes);
    　　document.cookie = `${name  }=${  escape(value)  }${(expireTimes == null) ? "" : `;expires=${exdate.toGMTString()}`};path=${`/${window.location.pathname.split("/")[1]}`}`;
    },
    getCookie(name){
        let c_start; let c_end;

        if (document.cookie.length > 0) {　　 
            c_start = document.cookie.indexOf(`${name  }=`);
        }
    　　if (c_start != -1) {　　　　　　　　
            c_start = c_start + name.length + 1;
    　　　　c_end = document.cookie.indexOf(";", c_start);
　　　　　　if (c_end == -1) {
                c_end = document.cookie.length;　　　　　
            } 　　　　　
            return unescape(document.cookie.substring(c_start, c_end));　　　
        }　
        　　　
        return "";
    },
    delCookie(name){
        this.setCookie(name, "", -1);
    },
    getEleClientWidth (){  // 获取浏览器内部窗口宽度
        return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    },
    getEleClientHeight (){  // 获取浏览器内部窗口高度
        return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    },
    _toNumber (value) {  // 转换值到数值类型
        if (this.isString(value)) {
            const valueParsed = parseFloat(value);
            if (isNaN(valueParsed) || valueParsed.toString() !== value) {
                value = NaN;
            } else {
                value = valueParsed;
            }
        }
        return this.isNumber(value) ? value : NaN;
    },
    _isNumber (value) {  // 判断值是否为number类型
        const number = this._toNumber(value);
        return !isNaN(number) && isFinite(number);
    },
    transformDate (milliseconds){  // 把时间戳转换成某种格式的时间字符串
        const d = new Date(milliseconds);
        const year = d.getFullYear();
        const month = (d.getMonth()+1) < 10 ? `0${  d.getMonth()+1}` : d.getMonth()+1;
        const date = d.getDate() < 10 ? `0${  d.getDate()}` : d.getDate();
        const hour = d.getHours() < 10 ? `0${d.getHours()}` : d.getHours();
        const minute = d.getMinutes() < 10 ? `0${  d.getMinutes()}` : d.getMinutes();
        const seconds = d.getSeconds() < 10 ? `0${  d.getSeconds()}` : d.getSeconds();
        const t = `${year}-${month}-${date} ${hour}:${minute}:${seconds}`;
        return t;
    },
    transitionEnd (){  // 检测浏览器是否支持transitionend事件
        // 创建一个元素用于测试
        const el = document.createElement("div");

        // 将所有主流浏览器实现方式整合成一个对象，用于遍历
        // key   是属性名称
        // value 是事件名称
        const transEndEventNames = {
            WebkitTransition : "webkitTransitionEnd",
            MozTransition    : "transitionend",
            OTransition      : "oTransitionEnd otransitionend",
            transition       : "transitionend"
        };

        // 循环遍历上面那个对象，判断 CSS 属性是否存在
        for (const name in transEndEventNames) {
            if (el.style[name] !== undefined) {
              return { transEndEventName: transEndEventNames[name] };
            }
        }

        return false;
    },
    // IE 下将 CSS 命名转换为驼峰表示法
    // background-color --> backgroundColor
    // 利用正则处理一下就可以了
    camelize(attr) {
        // /\-(\w)/g 正则内的 (\w) 是一个捕获，对应后面 function 的 letter
        // 意思是将 匹配到的 -x 结构的 x 转换为大写的 X (x 这里代表任意字母)
        return attr.replace(/\-(\w)/g, (all, letter) => letter.toUpperCase());
    },
    // IE 下获取透明度    
    getIEOpacity(elem) {
        let filter = null;

        // 早期的 IE 中要设置透明度有两个方法：
        // 1、alpha(opacity=0)
        // 2、filter:progid:DXImageTransform.Microsoft.gradient( GradientType= 0 , startColorstr = ‘#ccccc’, endColorstr = ‘#ddddd’ );
        // 利用正则匹配，注意 ?: 的用法
        filter = elem.style.filter.match(/(?:progid:[\w.]+.)?alpha\((?:[^,]+,)?\s*opacity=(\d+)\s*\)/i) || elem.style.filter.match(/alpha\(opacity=(.*)\)/i);

        if (filter) {
            const value = parseFloat(filter);
            if (!isNaN(value)) {
                // 转化为标准结果
                return value ? value / 100 : 0;
            }
        }
        // 默认返回 1
        return 1;
    },
    isDOM (obj,w){  // 判断一个对象是否是HTMLElement对象
        if(window.HTMLElement){
            return obj instanceof HTMLElement || (w ? obj instanceof w.HTMLElement : false);
        }
            return obj && typeof obj === "object" && obj.nodeType == 1 && typeof obj.nodeName === "string";
        
    },
    isOldIE(){  // 判断浏览器是否为IE5~8浏览器
        return "\v" === "v";
    },
    isIE(){  // 判断浏览器是否为IE浏览器
        if ("ActiveXObject" in window || !!window.ActiveXObject || window.navigator.appName === "Microsoft Internet Explorer" || window.navigator.userAgent.indexOf("MSIE") != -1){
            return true;
        }
            return false;
        
    },
    isFirefox(){  // 判断是否为Firefox浏览器
        const userAgent = window.navigator.userAgent.toLowerCase();
         if (userAgent.indexOf("firefox") != -1) {
            return true;
        }
            return false;
        
    },
    isChrome(){  // 判断是否为chrome浏览器
        const userAgent = window.navigator.userAgent.toLowerCase();
         if (userAgent.indexOf("chrome") != -1 && !this.isOpera()) {
            return true;
        }
            return false;
        
    },
    isOpera(){  // 判断是否为Opera浏览器
        const userAgent = window.navigator.userAgent.toLowerCase();
         if (userAgent.indexOf("opera") != -1 || userAgent.indexOf("opr") != -1) {
            return true;
        }
            return false;
        
    },
    isSafari(){  // 判断是否为Opera浏览器
        const userAgent = window.navigator.userAgent.toLowerCase();
         if (userAgent.indexOf("safari") != -1 && !this.isChrome() && !this.isOpera()) {
            return true;
        }
            return false;
        
    },
    getStyle(elem, style) {
        if(!this.isString(style)){
            return;
        }

        // 主流浏览器
        if (window.getComputedStyle) {
            // 获取 float 属性使用 cssFloat
            // 测试最新版的浏览器，使用 cssFloat 已经获取不到 float 了，直接使用下面的通用语法
            // if(style === 'float'){
            //  return win.getComputedStyle(elem, null).getPropertyValue('cssFloat');
            // }
            return window.getComputedStyle(elem, null).getPropertyValue(style);
        } 
            // 不支持 getComputedStyle 
            // IE下获取透明度
            if (style == "opacity") {
                return this.getIEOpacity(elem);

            // IE687 下获取浮动使用 styleFloat
            } if (style == "float") {
                return elem.currentStyle.getAttribute("styleFloat");

            // 未设置元素的高宽，获取的值是 auto
            // 这里要获取精确的 px 值，使用 elem.getBoundingClientRect 进行 hack
            // 跨浏览器的方法 getBoundingClientRect 可以获得元素四个点相对于文档视图左上角的值 top、left、bottom、right ，通过计算就可以容易地获得准确的元素大小
            } if ((style == "width" || style == "height") && (elem.currentStyle[style] == "auto")) {
                const clientRect = elem.getBoundingClientRect();

                // 加上 px ，转化为标准输出
                return `${style == "width" ? clientRect.right - clientRect.left : clientRect.bottom - clientRect.top  }px`;
            } if (style == "backgroundPosition" && this.isOldIE()) {
                return `${elem.currentStyle.backgroundPositionX } ${elem.currentStyle.backgroundPositionY}`;
            }

            // 其他样式，无需特殊处理
            return elem.currentStyle.getAttribute(this.camelize(style));
        
    },
    setStyle(elem,props,w){  // 为HTMLElement对象设置css属性
        if(this.isDOM(elem,w) && isPlainObject(props)){
            for(let p in props){
                // 如果是设置 opacity ，需要特殊处理
                if (p == "opacity") {
                    const value = props[p];
                    // IE7 bug:filter 滤镜要求 hasLayout=true 方可执行（否则没有效果）
                    if (!elem.currentStyle || !elem.currentStyle.hasLayout) {
                        // 设置 hasLayout=true 的一种方法
                        elem.style.zoom = 1;
                    }
                    // IE678 设置透明度叫 filter ，不是 opacity
                    p = "filter";

                    // !!转换为 boolean 类型进行判断
                    if (window.XDomainRequest) {
                        elem.style[p] = `progid:DXImageTransform.Microsoft.Alpha(style=0,opacity=${  value * 100  })`;
                    } else {
                        elem.style[p] = `alpha(opacity=${  value * 100  })`;
                    }
                }
                elem.style[p] = props[p];
            }
        }
    },  
    offset(elem){
        if(!this.isDOM(elem)){
            return null;
        }

        let _offsetParent = elem.offsetParent;
        let _offsetTop = elem.offsetTop;
        let _offsetLeft = elem.offsetLeft;
        const offset = {};

        while(_offsetParent){
            let parentBorderTopWidth = this.getStyle(_offsetParent,"border-top-width");
            let parentBorderLeftWidth = this.getStyle(_offsetParent,"border-left-width");

            if(this._isNaN(parseFloat(parentBorderTopWidth))){
                parentBorderTopWidth = 0;
            }
            if(this._isNaN(parseFloat(parentBorderLeftWidth))){
                parentBorderLeftWidth = 0;
            }

            if(_offsetParent.nodeName.toLowerCase() !== "body" && _offsetParent.nodeName.toLowerCase() !== "html"){
                _offsetTop += _offsetParent.offsetTop + parseFloat(parentBorderTopWidth);
                _offsetLeft += _offsetParent.offsetLeft + parseFloat(parentBorderLeftWidth);
            }else if(this.isFirefox()){
                    _offsetTop += parseFloat(parentBorderTopWidth);
                    _offsetLeft += parseFloat(parentBorderLeftWidth);
                }

            _offsetParent = _offsetParent.offsetParent;
        }

        offset.top = _offsetTop;
        offset.left = _offsetLeft;

        return offset;
    },
    position(elem){
        if(!this.isDOM(elem)){
            return null;
        }

        let a;
        const _offsetParent = elem.offsetParent;
        const b = this.offset(_offsetParent);
        const obj = {};
        let parentBorderTopWidth = parseFloat(this.getStyle(_offsetParent,"border-top-width"));
        let parentBorderLeftWidth = parseFloat(this.getStyle(_offsetParent,"border-left-width"));

        if(this._isNaN(parseFloat(parentBorderTopWidth))){
            parentBorderTopWidth = 0;
        }
        if(this._isNaN(parseFloat(parentBorderLeftWidth))){
            parentBorderLeftWidth = 0;
        }

        b.top += parentBorderTopWidth;
        b.left += parentBorderLeftWidth;

        if(this.getStyle(elem,"position") === "fixed"){
            a = elem.getBoundingClientRect();
        }else{
            a = this.offset(elem);
        }  

        obj.top = a.top - b.top - parseFloat(this.getStyle(elem,"margin-top"));
        obj.left = a.left - b.left - parseFloat(this.getStyle(elem,"margin-left"));

        return obj;
    },
    width(elem){
        const width = this.getStyle(elem,"width");
        return parseFloat(width);
    },
    height(elem){
        const height = this.getStyle(elem,"height");
        return parseFloat(height);
    },
    getIEVersion(){
        const reg = /msie ([\d.]*);/;
        const result = navigator.userAgent.toLowerCase().match(reg);
        if(result){
            return parseInt(result[1]);
        }
            return null;
        
    },
    scrollTop(val,elem){  // 设置或获取位于对象最顶端和窗口中可见内容的最顶端之间的距离
        if(elem && !this.isDOM(elem)){
            return;
        } 

        if(!this._isEmpty(val) && this.isNumber(val)){
            if(elem){
                elem.scrollTop = val;
                elem.scrollTop = val;
            }else{
                document.documentElement.scrollTop = val;
                document.body.scrollTop = val;
            }
        }else{
            let scrollTop;
            if(elem){
                scrollTop = elem.scrollTop;
                return scrollTop;
            }
                scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
                return scrollTop;
            
        }   
    },
    scrollLeft(val,elem){  // 设置或获取位于对象最顶端和窗口中可见内容的最顶端之间的距离
        if(elem && !this.isDOM(elem)){
            return;
        } 

        if(!this._isEmpty(val) && this.isNumber(val)){
            if(elem){
                elem.scrollLeft = val;
                elem.scrollLeft = val;
            }else{
                document.documentElement.scrollLeft = val;
                document.body.scrollLeft = val;
            }
        }else{
            let scrollLeft;
            if(elem){
                scrollLeft = elem.scrollLeft;
                return scrollLeft;
            }
                scrollLeft = document.documentElement.scrollLeft || window.pageXOffset || document.body.scrollLeft;
                return scrollLeft;
            
        }   
    },
    // fetch (options){  // 向服务器拉取数据（借助原生Promise），兼容IE9或以上（需添加Promise和fetch的兼容代码）
    //     let defaults = {
    //         url: '',
    //         method: 'get',           
    //         body: null,
    //         success: function(data){},
    //         fail: function(err){},
    //         dataType: 'json',
    //         headers: null
    //     };
    //     options = Object.assign({},defaults,options);
    //     let params = this.filterParam({method: options.method, body: options.body, credentials: options.credentials, headers: options.headers });

    //     fetch(options.url, params).then(function(res){
    //         if(res.status>=200 && res.status<300){
    //             return Promise.resolve(res);
    //         }
    //         else{
    //             return Promise.reject(res);
    //         }
    //     }).then(function(res){
    //         res = options.dataType == 'json' ? res.json() : (options.dataType == 'html' ? res.text() : res.json());
    //         return res;
    //     }).then((data)=>{
    //         if(this.isString(data)){
    //             data = JSON.parse(data);
    //         }
    //         if(this.isFunction(options.success)){
    //             options.success(data);
    //         }
    //     }).catch(function(err) {
    //         if(this.isFunction(options.fail)){
    //             options.fail(err);
    //         }
    //     }); 
    // },
    encryption (val){  // 加密(后台模式)
        const md5 = CryptoJS.MD5(val);
        const utf8 = CryptoJS.enc.Utf8.parse(md5);
        const base64 = CryptoJS.enc.Base64.stringify(utf8) || utf8.toString(CryptoJS.enc.Base64);
        return base64;
    },
    encryptionApp (val){  // 加密(app模式)
        const md5 = CryptoJS.MD5(val);
        const base64 = CryptoJS.enc.Base64.stringify(md5) || md5.toString(CryptoJS.enc.Base64);
        return base64;
    },
    encryption_base64 (val) {  // 加密（仅base64）
        const utf8 = CryptoJS.enc.Utf8.parse(val);
        const base64 = CryptoJS.enc.Base64.stringify(utf8) || utf8.toString(CryptoJS.enc.Base64);
        return base64;
    },
    decryption (val){  // 解密（仅base64）
        const base64 = CryptoJS.enc.Base64.parse(val);
        const utf8 = CryptoJS.enc.Utf8.stringify(base64);
        return utf8;
    },
    setEcharts (echartsInstance, callback) {  // echarts图表插件
        let options = null;

        if(this.isFunction(callback)){
            options = callback();
        }

        echartsInstance.setOption(options);
    },
    includes(arr, value) { // 判断值是否在数组中
        const _includes = Array.prototype.includes;

        if(_includes){
            return _includes.call(arr, value);
        }

        return arr.indexOf(value) >= 0;
    },
    returnResourceResult(authRightCodeList,page_code,pageEditJson,appComponent) {  // 用来返回是否  有权限查看该页面
        const _this = this;
        // 先确定权限集合已经获取到了
        let result = false;
        if(authRightCodeList[0] !== "null"){
            if(page_code instanceof Array){
                for(let i=0,len=page_code.length; i<len; i++){
                    if(_this.includes(authRightCodeList,page_code[i])){
                        result = true;
                    }
                }
            }else{
                result = _this.includes(authRightCodeList,page_code);

            }
            // 如果不应该展示  则给弹窗  并推路由到main
            if(!result){
                appComponent.props._setState({isShowAlert: true,messageAlert: pageEditJson.noPermissionMsg,leavedCallback:()=>{
                    appComponent.context.router.push({ pathname: "/main"});
                }});
            }
            return result;
        }
        return result;
    },
    // 面源分析内梅罗指数和土壤营养分级数据处理
    dealWithData(dataSource, pagination,flag=false){
        let columns = [
            {
                title: '序号',
                dataIndex: 'index',
                width: '5%',
                align: 'center',
                render: (value, row, index) => {
                    const { current, pageSize } = pagination;
                    return (current - 1) * pageSize + index  + 1;
                }
            },
            {
                title: '采样基地',
                dataIndex: 'baselandName',
                width: '10%',
                align: 'center',
                // onCell: (text) => ({
                //     style: {
                //     maxWidth: 150,
                //     overflow: 'hidden',
                //     whiteSpace: 'nowrap',
                //     textOverflow:'ellipsis',
                //     cursor:'pointer',
                //     },
                //     title: text.baselandName || ''
                // }),
                render: (value, row, index) => value||'--'
            },
            {
                title: '采样时间',
                width: '6%',
                dataIndex: 'measureTime',
                align: 'center',
                render: (value, row, index) => value && moment(value).format('YYYY-MM-DD') || '--'
            }
        ];
        if(!dataSource.length){
            return columns;
        }
        const columnCells = []; // 动态生成的面源项目指标，表格列的后几项
        let hasSyn = false; // 是否有 ‘综合指数’ 项
        dataSource.map(item => {
            if (item.polluteInfos.length) {
                item.polluteInfos.map(pollute => {
                    // 内梅罗指数或土壤营养分类项目名称动态生成列表表格列
                    if(!columnCells.some(item => item.id === pollute.polluteItemId)){
                        // 如果此项是综合指数，暂时不放入columnCells，让综合指数放在最后
                        if(pollute.polluteItemName !== '综合指数'){
                            columnCells.push({name: pollute.polluteItemName, id: pollute.polluteItemId});
                        }else{
                            hasSyn = true;
                        }
                    }
                })
            }
        });
        hasSyn&&columnCells.push({name: '综合指数', id: -1});
        // 将动态生成的表格放到antd table columns 中
        columnCells.map(cell => {
            cell&&columns.push({
              title: cell.name,
              dataIndex: cell.id===-1?null:cell.id,
              width: cell.name==='综合指数'?'6%':'5%',
              align: 'center',
              render: (value, row, index) => this.setCell(row, cell.id===-1?null:cell.id, index,flag)
            })
          })
        return columns;
    },
    // 设置内梅罗指数和土壤营养分级表单的内容
    setCell(row, id, index,flag) {
        let num;
        row.polluteInfos.map(ele => {
          if (ele.polluteItemId === id) {
              console.log(flag,"zxc");
              if(flag) ({ itemValue: num } = ele); 
              else ({ rangeValue: num } = ele);
            // (!flag?({ rangeValue: num } = ele):({ itemValue: num } = ele));
          }
        });
        return num == 0 ? 0 : num || '--';
    }
};

export default Tools;